import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

// Initial timetable structure
const initialTimetable = {
  Monday: {},
  Tuesday: {},
  Wednesday: {},
  Thursday: {},
  Friday: {}
};

const classesSlice = createSlice({
  name: 'classes',
  initialState: {
    subjects: [],
    timetable: initialTimetable,
    timetableView: 'table' // 'table' or 'card'
  },
  reducers: {
    // Subject management actions
    addSubject: (state, action) => {
      state.subjects.push({
        id: uuidv4(),
        name: action.payload,
        missedCount: 0,
        notes: '',
        expanded: false
      });
    },
    updateSubject: (state, action) => {
      const { id, name, missedCount } = action.payload;
      const subject = state.subjects.find(sub => sub.id === id);
      if (subject) {
        subject.name = name;
        subject.missedCount = missedCount;
      }
    },
    deleteSubject: (state, action) => {
      state.subjects = state.subjects.filter(sub => sub.id !== action.payload);
    },
    incrementMissed: (state, action) => {
      const subject = state.subjects.find(sub => sub.id === action.payload);
      if (subject) subject.missedCount++;
    },
    decrementMissed: (state, action) => {
      const subject = state.subjects.find(sub => sub.id === action.payload);
      if (subject && subject.missedCount > 0) subject.missedCount--;
    },
    toggleExpand: (state, action) => {
      const subject = state.subjects.find(sub => sub.id === action.payload);
      if (subject) subject.expanded = !subject.expanded;
    },
    updateNotes: (state, action) => {
      const subject = state.subjects.find(sub => sub.id === action.payload.id);
      if (subject) subject.notes = action.payload.notes;
    },

    // Timetable management actions
    updateTimetableSlot: (state, action) => {
      const { day, time, classData } = action.payload;
      if (!state.timetable[day]) {
        state.timetable[day] = {};
      }
      state.timetable[day][time] = classData;
    },
    deleteTimetableSlot: (state, action) => {
      const { day, time } = action.payload;
      if (state.timetable[day] && state.timetable[day][time]) {
        delete state.timetable[day][time];
      }
    },
    setTimetableView: (state, action) => {
      state.timetableView = action.payload;
    },
    clearTimetable: (state) => {
      state.timetable = initialTimetable;
    },
    importTimetable: (state, action) => {
      state.timetable = action.payload;
    },

    // Bulk operations
    addMultipleSubjects: (state, action) => {
      const subjects = action.payload.map(name => ({
        id: uuidv4(),
        name,
        missedCount: 0,
        notes: '',
        expanded: false
      }));
      state.subjects.push(...subjects);
    },
    resetAllMissedCounts: (state) => {
      state.subjects.forEach(subject => {
        subject.missedCount = 0;
      });
    }
  }
});

export const { 
  // Subject actions
  addSubject, 
  updateSubject, 
  deleteSubject, 
  incrementMissed, 
  decrementMissed, 
  toggleExpand, 
  updateNotes,
  addMultipleSubjects,
  resetAllMissedCounts,
  
  // Timetable actions
  updateTimetableSlot,
  deleteTimetableSlot,
  setTimetableView,
  clearTimetable,
  importTimetable
} = classesSlice.actions;

export default classesSlice.reducer;















